import { Component, HostListener, inject, ViewEncapsulation, ChangeDetectionStrategy } from '@angular/core';
import { translate, TranslocoDirective } from '@jsverse/transloco';
import { LayoutService } from '../../../@vex/services/layout.service';
import { MatDialogRef, MatDialogTitle, MatDialogContent, MatDialogActions } from '@angular/material/dialog';
import { MatIconButton, MatButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { CdkDrag, CdkDragHandle } from '@angular/cdk/drag-drop';
import { CdkScrollable } from '@angular/cdk/scrolling';

@Component({
	selector: 'ara-confirmation-dialog',
	templateUrl: './confirmation-dialog.component.html',
	styleUrls: ['./confirmation-dialog.component.scss'],
	encapsulation: ViewEncapsulation.None,
	changeDetection: ChangeDetectionStrategy.Eager,
	imports: [TranslocoDirective, MatIconButton, MatIcon, MatDialogTitle, CdkDrag, CdkDragHandle, CdkScrollable, MatDialogContent, MatDialogActions, MatButton],
})
export class ConfirmationDialogComponent {
	private readonly layoutService = inject(LayoutService);
	protected readonly dialogRef = inject(MatDialogRef<ConfirmationDialogComponent>);

	showConfirmButton = true;
	showCloseButton = true;
	closeButtonText = translate('common.false');
	confirmButtonText = translate('common.true');
	closeOnEscapeKey = false;
	isMobile = this.layoutService.isMobile();

	public titleMessage = '';
	public confirmMessage = '';

	@HostListener('document:keydown.escape', ['$event'])
	onEscapeKey(event: Event): void {
		if (this.closeOnEscapeKey) {
			event.preventDefault();
			this.dialogRef.close(false);
		}
	}
}
